<template>
    <a
        @click="handleClick"
        :href="href"
        :target="target"
        :data-app-event="eventName"
        :data-app-argument="eventArgument"
        v-bind="attributes"
    >
        <DsIcon :width="16" :height="16" v-if="iconLeft" :name="iconLeft" />
        <slot></slot>
        <DsIcon :width="16" :height="16" v-if="iconRight" :name="iconRight" />
    </a>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { isMobileApp, triggerMobileAppEvent } from "../mobile-app-integration";
import type { MobileAppMethodName } from "../mobile-app-models";
import DsIcon from "@sazka/design-system/src/icon/ds-icon.vue";
import type { SvgIcons } from "@sazka/design-system/src/icon/types";

const props = defineProps<{
    href: string;
    target?: "_blank" | "_self";
    eventName?: MobileAppMethodName | Omit<string, MobileAppMethodName>;
    eventArgument?: string;
    iconLeft?: SvgIcons;
    iconRight?: SvgIcons;

    /**
     * For links in ours web - e.g. pages, pdf documents...
     */
    openInNewTab?: boolean;

    /**
     * For external links that link outside of our website
     */
    isExternal?: boolean;
}>();

const emit = defineEmits(["linkClicked"]);

const attributes = computed(() => {
    const attributes: Record<string, string | null> = {
        target: null,
        rel: null,
    };

    if (props.openInNewTab || props.isExternal) {
        attributes.target = "_blank";
        attributes.rel = "noopener";
    }
    if (props.isExternal) {
        attributes.rel += " noreferrer";
    }

    return attributes;
});

const handleClick = (event: Event) => {
    emit("linkClicked");

    if (props.eventName && isMobileApp) {
        event.preventDefault();
        triggerMobileAppEvent(props.eventName as string, props.eventArgument);
    }
};
</script>
